import type { PostVerdictRecap } from "@/hooks/use-post-verdict";

export function PostVerdictRecapCard({ recap }: { recap: PostVerdictRecap }) {
  return (
    <section data-testid="post-verdict-recap" data-rp="recap-collapse" style={{ marginBottom: 48 }}>
      <div
        style={{
          fontFamily: '"DM Mono", monospace',
          fontSize: 10,
          letterSpacing: 3,
          textTransform: "uppercase",
          color: "var(--gold-deep)",
        }}
      >
        — Post-verdict · Dialogue privé avec le porte-parole
      </div>
      <div
        aria-hidden
        style={{ width: 24, height: 1, background: "var(--terracotta)", margin: "12px 0" }}
      />
      <div
        style={{
          background: "var(--cream)",
          border: "0.5px solid var(--stone-mid)",
          padding: "18px 22px",
        }}
      >
        <div
          style={{
            fontFamily: '"DM Mono", monospace',
            fontSize: 9,
            letterSpacing: 2,
            textTransform: "uppercase",
            color: "var(--leather)",
            marginBottom: 6,
          }}
        >
          Verdict rendu · N° {recap.saisineNumber}
        </div>
        <div
          style={{
            fontFamily: '"Playfair Display", serif',
            fontStyle: "italic",
            fontSize: 16,
            color: "var(--charcoal)",
            lineHeight: 1.4,
          }}
        >
          {recap.question}
        </div>
        <div
          style={{
            fontFamily: '"Cormorant Garamond", serif',
            fontStyle: "italic",
            fontSize: 18,
            fontWeight: 500,
            color: "var(--leather)",
            marginTop: 8,
          }}
        >
          → {recap.headlineSynthesis}
        </div>
      </div>
    </section>
  );
}

export default PostVerdictRecapCard;
